// @flow
import * as React from 'react'
import HelpIcon from 'mz-icons/question-circle'
import InfoIcon from 'mz-icons/info-circle'
import ErrorIcon from 'mz-icons/exclamation-circle'
import CheckIcon from 'mz-icons/check-circle'
import { HelpContainer, IconWrapper } from './elements'

// Types
export type Props = {
  icon?: React.Node,
  children: React.Node,
  type?: 'help' | 'info' | 'error' | 'warning' | 'success',
}

// Utils
const TYPE_TO_ICON = {
  help: HelpIcon,
  info: InfoIcon,
  error: ErrorIcon,
  warning: ErrorIcon,
  success: CheckIcon,
}

/**
 * A little component to show some static information below the field
 * @param {React.Node} children
 * @param {string} type
 */
function FieldHelp({ children, icon, type }: Props) {
  const safeIconType = type && TYPE_TO_ICON[type] ? type : 'help'
  const Icon = TYPE_TO_ICON[safeIconType]

  return (
    <HelpContainer $type={safeIconType}>
      <IconWrapper>{icon || <Icon />}</IconWrapper>
      {children}
    </HelpContainer>
  )
}
FieldHelp.defaultProps = {
  type: 'help',
}

export default FieldHelp
